<div class="months">
  <a class="days" *ngFor="let days of allDays; let i = index" [class.current]="index === i" [routerLink]="['/calendar', availableMonths[i]]">
    <div class="month-name">{{ monthNames[i] }}</div>
    <div class="day" *ngFor="let day of days" [class.current]="day.current" [class.active]="day.active"></div>
  </a>
</div>
